<template>
<div class="blank">
    <group gutter="8">
        <cell title="II类户开户代扣协议" @click="nextRoute('persh')">
            <div slot="right">
                    <img class="icon" src="../assets/images/link.png" height="12" width="7" alt="">
                </div>
        </cell>
        <cell title="个人信息使用授权" @click="nextRoute('perauthorize')">
            <div slot="right">
                    <img class="icon" src="../assets/images/link.png" height="12" width="7" alt="">
                </div>
        </cell>
    </group>
</div>
</template>

<script>
    import {
        Group,
        Cell
    } from 'fiui'

    export default {
        components: {
            Group,
            Cell
        },
        beforeRouteEnter (to, from, next) {
            document.title = '相关协议'
            next()
        },
        methods: {
            nextRoute (route) {
                this.$router.push(route)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// protocollist.vue?33a32c04